var map = {
	"./bulma-16x16.png": "9a23",
	"./bulma-32x32.png": "2a9f",
	"./flag-en-us-32x32.png": "23d8",
	"./flag-en-us-favicon-16x16.png": "9c27",
	"./flag-pt-br-16x16.png": "05db",
	"./flag-pt-br-32x32.png": "89d7",
	"./tiagoj.co-16x16.png": "2488",
	"./tiagoj.co-32x32.png": "232f",
	"./vue.js-16x16.png": "c62e",
	"./vue.js-32x32.png": "99bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";